export function OpenReport(base64String, fileName = 'Report.pdf') {
    if (!base64String) {
        console.error("No report data found");
        return;
    }

    try {
        // Convert Base64 string to a Blob
        const binaryString = window.atob(base64String);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: 'application/pdf' });

        // Create a URL for the Blob
        const blobUrl = URL.createObjectURL(blob);

        // Ensure the new tab opens from a user-triggered event
        const newTab = window.open();
        if (newTab) {
            newTab.document.write('<html><body><embed src="' + blobUrl + '" width="100%" height="100%"></embed></body></html>');
            newTab.document.close();
        } else {
            console.error('Failed to open new tab due to popup blocker');
        }

        // Trigger the download with the dynamic filename
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoke the Blob URL after use to free memory
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);

    } catch (error) {
        console.error("Error processing the report:", error);
    }
}
